module.exports = __webpack_public_path__ + "img/advantage7.7ae35a3d.png";